module.exports = __webpack_public_path__ + "img/pufa.3a6efb84.png";